// extracted by mini-css-extract-plugin
export var image = "_ic-1";
export var imageContainer = "_ic-0";